export default __webpack_public_path__ + "static/media/washupVoucher2.5429334c.png";